import {Route, Routes} from "react-router-dom";
import DeviceList from "./DeviceList";
import RequireAuth from "../../components/RequireAuth";
import DeviceDetails from "./DeviceDetails";
import {PermissionLevel} from "../../app/api/model/user";

export default function Devices() {
    return (
        <RequireAuth permissionLevel={PermissionLevel.VIEW_ONLY}>
            <Routes>
                <Route index element={<DeviceList />} />
                <Route path=":deviceId" element={<DeviceDetails />} />
            </Routes>
        </RequireAuth>
    );
}
